import { useCallback, useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { FaCheckCircle } from 'react-icons/fa'
import { toast } from 'react-toastify'
import ProdutosService from '../../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { CustomButton } from '../../CustomButton'
import { CustomPriceInput } from '../../CustomPriceInput'

export function ModalEditarPrecos({ productData, isOpen, onClose }) {
  const [data, setData] = useState({
    precocusto: '',
    precovenda: '',
    precoatacado: '',
    precovarejo_p: '',
    precoatacado_p: '',
  })

  const [isLoadingProduct, setIsLoadingProduct] = useState(true)
  const [isLoadingRequest, setIsLoadingRequest] = useState(false)

  function handleChange(e) {
    const { name, value } = e.target

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  async function handleSubmit() {
    try {
      setIsLoadingRequest(true)

      await ProdutosService.updatePrices(productData.CODPRODUTO, {
        precocusto: data.precocusto,
        precovenda: data.precovenda,
        precoatacado: data.precoatacado,
        precovarejo_p: data.precovarejo_p,
        precoatacado_p: data.precoatacado_p,
      })

      toast.success('Preços salvo com sucesso!')

      loadPrices()
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar os preços')
    } finally {
      setIsLoadingRequest(false)
    }
  }

  const loadPrices = useCallback(async () => {
    try {
      setIsLoadingProduct(true)

      const product = await ProdutosService.getById(productData.CODPRODUTO)

      setData({
        precocusto: product.PRECOCUSTO,
        precovenda: product.PRECOVENDA,
        precoatacado: product.PRECOATACADO,
        precovarejo_p: product.PRECOVAREJO_P,
        precoatacado_p: product.PRECOATACADO_P,
      })
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao atualizar os preços!')
    } finally {
      setIsLoadingProduct(false)
    }
  }, [productData.CODPRODUTO])

  useEffect(() => {
    loadPrices()
  }, [loadPrices])

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Editar Preço</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <Form.Label>Preço Custo</Form.Label>
            <CustomPriceInput
              name="precocusto"
              value={data.precocusto}
              onChange={handleChange}
              placeholder={isLoadingProduct ? 'Carregando...' : 'R$ 0,00'}
              disabled={isLoadingProduct}
            />
          </Col>

          <Col>
            <Form.Label>Preço Venda</Form.Label>
            <CustomPriceInput
              name="precovenda"
              value={data.precovenda}
              onChange={handleChange}
              disabled={isLoadingProduct}
              placeholder={isLoadingProduct ? 'Carregando...' : 'R$ 0,00'}
            />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <Form.Label>Preço Atacado</Form.Label>
            <CustomPriceInput
              name="precoatacado"
              value={data.precoatacado}
              onChange={handleChange}
              placeholder={isLoadingProduct ? 'Carregando...' : 'R$ 0,00'}
              disabled={isLoadingProduct}
              isDisabled={isLoadingProduct}
            />
          </Col>

          <Col>
            <Form.Label>Preço Prom. Varejo</Form.Label>
            <CustomPriceInput
              name="precovarejo_p"
              value={data.precovarejo_p}
              disabled={isLoadingProduct}
              onChange={handleChange}
              placeholder={isLoadingProduct ? 'Carregando...' : 'R$ 0,00'}
            />
          </Col>
        </Row>

        <Row
          xs={2}
          className="mb-3"
        >
          <Col>
            <Form.Label>Preço Prom. Atacado</Form.Label>
            <CustomPriceInput
              name="precoatacado_p"
              value={data.precoatacado_p}
              disabled={isLoadingProduct}
              onChange={handleChange}
              placeholder={isLoadingProduct ? 'Carregando...' : 'R$ 0,00'}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <CustomButton
          title="Salvar"
          color="#059743"
          onClick={handleSubmit}
          isLoading={isLoadingRequest}
          isLoadingText="Salvando..."
        >
          <FaCheckCircle />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
